import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "center"
const options = {role: ROLE.CENTER};


export const userProfileDetails = async () => {
  // return await axiosInstance(options).get(`${path}/user/details`);
}
export const updateUserProfile = async (values , o_id) => {
    // return await axiosInstance(options).put(`${path}/user/edit`, values);
}

export const updateInitialPassword = async (values) => {
  return await axiosInstance(options).patch(`${path}/user/change-initial-password`, values);
}
export const updateUserPassword = async (values) => {
  return await axiosInstance(options).patch(`${path}/user/update-password`, values);
}

export const updateCenterProfile = async (values) => {
  return await axiosInstance(options).put(`${path}/user/edit`, values);
}
export const centerProfileDetails = async () => {
    return await axiosInstance(options).get(`${path}/user/details`);
}

